import commaNumber from 'comma-number';
import capitalize from 'lodash/capitalize';
import { formatDate } from 'src/util/helpers';
import Bar from 'src/components/charts/Bar';
import Line from 'src/components/charts/Line';
import Loading from 'src/components/Loading';
import Modal from 'src/components/Modal';
import Navigation from 'src/components/Navigation';
import Pie from 'src/components/charts/Pie';
import RightCarat from 'src/components/icons/RightCarat';
import Search from 'src/components/icons/Search';
import ThinLinePie from 'src/components/charts/ThinLinePie';
import Tooltip from 'src/components/Tooltip';
import UpArrow from 'src/components/icons/UpArrow';
import BackToTop from 'src/components/BackToTop';
import InterestForm from 'src/components/InterestForm';
import FeedbackToggle from 'src/components/FeedbackToggle';
import LazyImage from 'src/components/LazyImage';
import VLazyImage from 'v-lazy-image';

Vue.component('up-arrow', UpArrow);
Vue.component('right-carat', RightCarat);
Vue.component('search-icon', Search);
Vue.component('line-chart', Line);
Vue.component('bar-chart', Bar);
Vue.component('pie-chart', Pie);
Vue.component('thin-line-pie-chart', ThinLinePie);
Vue.component('navigation', Navigation);
Vue.component('loading', Loading);
Vue.component('tooltip', Tooltip);
Vue.component('modal', Modal);
Vue.component('back-to-top', BackToTop);
Vue.component('interest-form', InterestForm);
Vue.component('feedback-toggle', FeedbackToggle);
Vue.component(
    'lazy-image',
    'loading' in HTMLImageElement.prototype ? LazyImage : VLazyImage,
);

Vue.directive('focus', {
    inserted(el, binding) {
        if (binding.value !== false) {
            el.focus();
        }
    },
});

Vue.filter('capitalize', value => capitalize(value));

Vue.filter('decimal', value => value.toFixed(2));

Vue.filter('commaNumber', value => commaNumber(value));

Vue.filter('wholeCommaNumber', value => commaNumber(Math.round(value)));

Vue.filter('percentage', value => {
    return `${value.toFixed(2)}%`;
});

const toMoney = (value, includeCents = true) => {
    const result = commaNumber(includeCents ? value.toFixed(2) : value);

    if (result.indexOf('-') > -1) {
        return result.replace('-', '-$');
    }

    return '$' + result;
};

Vue.filter('money', value => toMoney(value));
Vue.filter('moneyRounded', value => toMoney(value, false));

Vue.filter('date', formatDate);
